export type { ModalVariants } from './ErrorModal';
export { ErrorModal } from './ErrorModal';
